import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '~/lib/api';

export const Route = createFileRoute('/_authed/history')({
  component: History,
});

function formatDate(ms: number): string {
  return new Date(ms).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

function History() {
  const [q, setQ] = useState('');
  const trimmed = q.trim();

  const list = useQuery({
    queryKey: ['entries'],
    queryFn: () => api.listEntries(),
    enabled: trimmed.length === 0,
  });

  const search = useQuery({
    queryKey: ['entries-search', trimmed],
    queryFn: () => api.searchEntries(trimmed),
    enabled: trimmed.length > 0,
  });

  return (
    <section className="mx-auto max-w-2xl px-4 py-12">
      <div className="flex items-baseline justify-between">
        <h1 className="text-2xl font-semibold tracking-tight">history</h1>
        <span className="text-xs text-muted-foreground">
          {trimmed ? 'semantic search' : 'most recent first'}
        </span>
      </div>

      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="find when I felt…"
        className="mt-6 w-full h-11 rounded-[var(--radius)] border border-input bg-background px-3 text-base focus:outline-none focus:ring-2 focus:ring-ring"
      />

      <ul className="mt-8 space-y-3">
        {trimmed === ''
          ? (list.data?.entries ?? []).map((e) => (
              <li
                key={e.id}
                className="rounded-[var(--radius)] border border-border p-4"
              >
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>{e.modality}</span>
                  <span>{formatDate(e.createdAt)}</span>
                </div>
                <p className="mt-2 whitespace-pre-wrap">{e.snippet || <span className="text-muted-foreground">(empty)</span>}</p>
              </li>
            ))
          : (search.data?.hits ?? []).map((h) => (
              <li
                key={h.id}
                className="rounded-[var(--radius)] border border-border p-4"
              >
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>
                    {h.modality} · score {h.score.toFixed(2)}
                  </span>
                  <span>{formatDate(h.createdAt)}</span>
                </div>
                <p className="mt-2 whitespace-pre-wrap">{h.snippet}</p>
              </li>
            ))}
      </ul>

      {trimmed === '' && list.data && !list.data.entries.length && (
        <p className="mt-12 text-sm text-muted-foreground">
          nothing here yet. capture something on the today view.
        </p>
      )}
      {trimmed !== '' && search.data && !search.data.hits.length && !search.isFetching && (
        <p className="mt-12 text-sm text-muted-foreground">no matches.</p>
      )}
    </section>
  );
}
